module.exports = "/assets/5398a198947d5f67e0a018b51cf856ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UA.png
// module id = 3003
// module chunks = 0